import { render } from "./Bokeh.vue?vue&type=template&id=1ea9fc74&scoped=true"
import script from "./Bokeh.vue?vue&type=script&lang=js"
export * from "./Bokeh.vue?vue&type=script&lang=js"

import "./Bokeh.vue?vue&type=style&index=0&id=1ea9fc74&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ea9fc74"]])

export default __exports__